<template>
  <router-link
    class="event-link"
    :to="{ name: 'mqmark', params: { trackid: trackid, subject : subject } }"
  >
    <div class="event-card -shadow p-2 m-2">
      <h4 class="title mt-1">
        {{ subject }}
      </h4>
      <b-row>
        <b-col cols="9">
          
        </b-col>
      </b-row>
    </div>
  </router-link>
</template>

<script>
export default {
  props: ["subject", 'trackid']
};
</script>

<style scoped>
.icon {
  width: 25px;
  height: 25px;
  margin-right: 5px;
}

.event-card {
  transition: all 0.2s linear;
  cursor: pointer;
  background-color: lightgray;
  border-radius: 10px 10px;
}

.event-card:hover {
  transform: scale(1.01);
  box-shadow: 0 3px 12px 0 rgba(0, 0, 0, 0.2), 0 1px 15px 0 rgba(0, 0, 0, 0.19);
}

.event-link {
  color: black;
  text-decoration: none;
}
</style>
